import { Capacitor } from "@capacitor/core";

let foregroundPermissionPromise = null;

export function getAndroidGPSPlugin() {
  try {
    return (
      window?.Capacitor?.Plugins?.GPSNativePlugin ||
      window?.Capacitor?.Plugins?.GPSNative ||
      Capacitor?.Plugins?.GPSNativePlugin ||
      Capacitor?.Plugins?.GPSNative ||
      null
    );
  } catch {
    return null;
  }
}

export async function ensureAndroidForegroundLocationPermission() {
  if (!Capacitor?.isNativePlatform?.() || Capacitor?.getPlatform?.() !== "android") {
    return true;
  }

  if (foregroundPermissionPromise) return foregroundPermissionPromise;

  foregroundPermissionPromise = (async () => {
    try {
      const plugin = getAndroidGPSPlugin();
      if (!plugin?.checkPermissions) return false;

      let permissions = await plugin.checkPermissions();
      if (permissions?.location !== "granted") {
        await plugin.requestPermissions?.();
        permissions = await plugin.checkPermissions();
      }

      return permissions?.location === "granted";
    } catch {
      return false;
    }
  })();

  try {
    return await foregroundPermissionPromise;
  } finally {
    foregroundPermissionPromise = null;
  }
}
